module.exports = __webpack_public_path__ + "static/media/fin_up4.62e870ea.jpg";